module.exports = __webpack_public_path__ + "img/pillImage.cb9d3dea.png";